import gql from 'graphql-tag'

import apolloClient from '@/vendor/apollo'

export function remind (cycleId, type, userIds) {
  return apolloClient.mutate({
    mutation: gql`
      mutation Remind ($type: ActionType!, $cycleId: Int, $userIds: [Int]!) {
        remind_to_action (action_type: $type, cycle_id: $cycleId, user_ids: $userIds)
      }
    `,
    variables: {
      cycleId,
      type,
      userIds
    }
  })
}
